module.exports = __webpack_public_path__ + "img/herb-1.d60a96c3.png";